import {
    NEW_CULTURA_CADASTRO_SUCCESS,
    CANCEL_CULTURA_CADASTRO_RAPIDO,
    CANCEL_CULTURA_CADASTRO_RAPIDO_SUCCESS,
    TABLE_CULTURA_CADASTRO_PENDING,
    TABLE_CULTURA_CADASTRO_SUCCESS,
    TABLE_CULTURA_CADASTRO_FAILURE,
    LIST_CULTURA_CADASTRO_PENDING,
    LIST_CULTURA_CADASTRO_SUCCESS,
    LIST_CULTURA_CADASTRO_FAILURE,
    FIND_CULTURA_CADASTRO_PENDING,
    FIND_CULTURA_CADASTRO_SUCCESS,
    FIND_CULTURA_CADASTRO_FAILURE,
    DELETE_CULTURA_CADASTRO_PENDING,
    DELETE_CULTURA_CADASTRO_SUCCESS,
    DELETE_CULTURA_CADASTRO_FAILURE,
    CREATE_CULTURA_CADASTRO_PENDING,
    CREATE_CULTURA_CADASTRO_SUCCESS,
    CREATE_CULTURA_CADASTRO_FAILURE,
} from './actionTypes';


const initialState = { list: null, loading: false }


function culturaCadastroReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_CULTURA_CADASTRO_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: action.isCadastroRapido ?? false,
            }
        case LIST_CULTURA_CADASTRO_PENDING:
        case FIND_CULTURA_CADASTRO_PENDING:
        case DELETE_CULTURA_CADASTRO_PENDING:
        case CREATE_CULTURA_CADASTRO_PENDING:
        case TABLE_CULTURA_CADASTRO_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CANCEL_CULTURA_CADASTRO_RAPIDO:
        case CANCEL_CULTURA_CADASTRO_RAPIDO_SUCCESS:
            return {
                ...state,
                isCadastroRapido: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_CULTURA_CADASTRO_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_CULTURA_CADASTRO_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_CULTURA_CADASTRO_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_CULTURA_CADASTRO_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_CULTURA_CADASTRO_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_CULTURA_CADASTRO_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_CULTURA_CADASTRO_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_CULTURA_CADASTRO_SUCCESS:
        case CREATE_CULTURA_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro,
                isCadastroRapido: false,
            }
        case DELETE_CULTURA_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { culturaCadastroReducer };